import { createContext, useContext, useEffect } from "react";

// La empresa abierta: la pantalla que la cargó le dice al marco su nombre y su código (el título de la barra, C49) sin
// que el marco tenga que volver a pedirla. El marco recuerda las últimas 4 abiertas para «Recientes», por persona.

export type OpenOrg = { id: number; name: string; code: string };

/** null: todavía no se sabe; "missing": la empresa de la dirección no existe o no está en la cartera. */
export type OrgSignal = OpenOrg | null | "missing";

export const OpenOrgContext = createContext<(org: OrgSignal) => void>(() => undefined);

/** El estado «No encontramos esta empresa» avisa al marco para que la barra quede como el directorio. */
export function useMissingOrg() {
  const set = useContext(OpenOrgContext);
  useEffect(() => {
    set("missing");
  }, [set]);
}

/** La pantalla de una empresa avisa cuál es al cargarla (y null si no la encontró). */
export function useOpenOrg(org: OpenOrg | null) {
  const set = useContext(OpenOrgContext);
  const id = org?.id ?? 0;
  const name = org?.name ?? "";
  const code = org?.code ?? "";
  useEffect(() => {
    set(id ? { id, name, code } : null);
  }, [set, id, name, code]);
}

const recentKey = (userId: number) => `bheli-admin-recent-orgs:${userId}`;

/** Últimas empresas abiertas por esta persona en este navegador (comodidad; nunca decide permisos). */
export function readRecentOrgs(userId: number): OpenOrg[] {
  try {
    const value = JSON.parse(localStorage.getItem(recentKey(userId)) ?? "[]") as OpenOrg[];
    return Array.isArray(value) ? value.filter((item) => item && item.id > 0 && item.name).slice(0, 4) : [];
  } catch {
    return [];
  }
}

export function rememberOrg(userId: number, org: OpenOrg): OpenOrg[] {
  const next = [org, ...readRecentOrgs(userId).filter((item) => item.id !== org.id)].slice(0, 4);
  try {
    localStorage.setItem(recentKey(userId), JSON.stringify(next));
  } catch {
    // Sin almacenamiento la lista vive solo mientras la pestaña está abierta.
  }
  return next;
}
